module.exports = __webpack_public_path__ + "img/calendar.e2167b53.svg";